import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageSegmentLoadMark } from '../Bm3PageSegmentLoadMark.tsx';
import type { Props } from '../Bm3PageSegmentLoadMark.tsx';

/**
 * Interop component that renders either null (under UFO, since segment marks
 * are handled natively) or the legacy Bm3PageSegmentLoadMark (which creates BM3
 * marks) based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageSegmentLoadMark = (props: Props) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return null;
	}

	return <Bm3PageSegmentLoadMark {...props} />;
};
